import { VALUATIONS_TRANSACTION_ID_VALIDATION_REGEX } from 'common/constants/valuations';
import { getStringValue, regexValidator } from 'utillities';

const regex = new RegExp(VALUATIONS_TRANSACTION_ID_VALIDATION_REGEX);

const transactionIdValidator = (value?: string): boolean => regexValidator(regex, getStringValue(value));

export default transactionIdValidator;
